import { authCookies } from "@/services/cookies";
import { Repo } from "@/store/admin/repo";

export default function isAuth({ next }) {
  if (!authCookies.hasSession()) {
    return next({
      name: "Auth",
    });
  }

  const user = authCookies.getUser();
  if (user && Object.keys(user).length) {
    Repo.user = user;
  }

  return next();
}
